module.exports = __webpack_public_path__ + "img/busca-ornamentales.4bd20b5a.jpg";